// libs
import React, { memo } from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// helpers
import { inPriceFormat } from 'shared/helpers/utils';

//hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// styles
import { Container, Discount, Amount, Title, Text, PriceRevealContainer, Pipe } from './styles';

// constants
import { DEFAULT_CURRENCY } from 'shared/constants';

const DISCOUNT_TEXT = '%';

export interface IPriceWithDiscountProps {
  priceRevealData?: Listing.IPriceRevealData;
}

function PriceReveal({ priceRevealData }: IPriceWithDiscountProps) {
  const formattedPrice = inPriceFormat(priceRevealData?.sp);
  const priceRevealConfig = get(
    useRemoteConfig('priceReveal'),
    'plp',
    null
  ) as Listing.IPriceRevealPlpConfig;

  if (isEmpty(priceRevealData)) return null;

  return (
    <PriceRevealContainer>
      <Pipe color={priceRevealConfig?.pipeColor} />
      <Title>
        <Text color={priceRevealConfig?.titleColor}>{priceRevealConfig?.title}</Text>
      </Title>
      <Container>
        <Amount color={priceRevealConfig?.amountColor}>
          {DEFAULT_CURRENCY}
          {formattedPrice}
        </Amount>
        <Discount color={priceRevealConfig?.discountColor}>
          ({priceRevealData?.discount}
          {DISCOUNT_TEXT})
        </Discount>
      </Container>
    </PriceRevealContainer>
  );
}

export default memo(PriceReveal);
